import { CONFIG_MULTI_POOL_AUTH_ENABLED } from '@src/config/env'
import {
  UserAgnosticGlobalFeatureGates,
  userAgnosticGlobalFeatureGatesDefaults,
} from '@src/server-side/api/feature-gates.types'

let userAgnosticGlobalFeatureGates: UserAgnosticGlobalFeatureGates = userAgnosticGlobalFeatureGatesDefaults

/**
 * Seeds the in-memory feature gates from Next.js `__NEXT_DATA__` (same payload the server put in HTML).
 * Call from browser module scope before code that reads `getUserAgnosticGlobalFeatureGatesFromMemory()` (e.g.
 * universal-auth `configureAuth`), so SSR-known gates are available before `MyApp` runs.
 */
export function hydrateUserAgnosticGlobalFeatureGatesFromNextData(): void {
  if (typeof globalThis.window === 'undefined') {
    return
  }

  const nextData = (
    globalThis as typeof globalThis & {
      __NEXT_DATA__?: { props?: { pageProps?: { userAgnosticGlobalFeatureGates?: unknown } } }
    }
  ).__NEXT_DATA__
  const pageProps = nextData?.props?.pageProps
  const fromPage = pageProps?.userAgnosticGlobalFeatureGates

  if (fromPage && typeof fromPage === 'object' && !Array.isArray(fromPage)) {
    setUserAgnosticGlobalFeatureGatesInMemory({
      ...userAgnosticGlobalFeatureGatesDefaults,
      ...(fromPage as Partial<UserAgnosticGlobalFeatureGates>),
    })
  }
}

export function setUserAgnosticGlobalFeatureGatesInMemory(featureGates?: UserAgnosticGlobalFeatureGates | null) {
  if (featureGates) {
    userAgnosticGlobalFeatureGates = featureGates
    // Cleanup the feature gate if the multi pool auth is enabled for all regions
    if (CONFIG_MULTI_POOL_AUTH_ENABLED) {
      userAgnosticGlobalFeatureGates.multi_pool_auth_enabled = true
    }
  }
}

export function getUserAgnosticGlobalFeatureGatesFromMemory(): UserAgnosticGlobalFeatureGates {
  // Cleanup the feature gate if the multi pool auth is enabled for all regions
  if (CONFIG_MULTI_POOL_AUTH_ENABLED) {
    userAgnosticGlobalFeatureGates.multi_pool_auth_enabled = true
  }
  return userAgnosticGlobalFeatureGates
}
